export function validatePassword(password: string): string | null {
  const errors = [];
  if (password.length < 8) errors.push('Minimum 8 characters.');
  if (!/[A-Z]/.test(password)) errors.push('At least one uppercase letter.');
  if (!/[a-z]/.test(password)) errors.push('At least one lowercase letter.');
  if (!/[0-9]/.test(password)) errors.push('At least one number.');
  if (!/[!@#$%^&*]/.test(password)) errors.push('At least one special character.');
  return errors.length ? errors.join(' ') : null;
}

export function checkPasswordMatch(password: string, confirmPassword: string): string | null {
  if (password !== confirmPassword) {
    return 'Passwords do not match.';
  }
  return null;
}

export function getPasswordStrength(password: string): 'weak' | 'medium' | 'strong' {
  let score = 0;
  if (password.length >= 8) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[!@#$%^&*]/.test(password)) score++;
  
  if (score <= 2) return 'weak';
  if (score <= 4) return 'medium';
  return 'strong';
} 